// Core scalar constants
import { GroupConfig, HuntrixMember, IdolRank, CostumeId, StreetFoodQuest } from '../types';

export const INITIAL_PLAYER_CASH = 50000;
export const BOBBY_COMMISSION = 0.03;
export const MAX_SKILL = 99;
export const VICTORY_BONUS_CASH = 5000000;
export const VICTORY_BONUS_FANS = 1000000;
